import Vue from 'vue'
import { Module } from 'vuex'
import { RootState } from '@/store'

export const initStoreModule = (storeModuleName: string, store: Module<any, RootState>) => {
  return Vue.extend({
    async beforeCreate () {
      await this.$store.registerModule(storeModuleName, store)
    },
    async beforeDestroy () {
      await this.$store.unregisterModule(storeModuleName)
    }
  })
}
